import { forwardRef, useEffect, useImperativeHandle, useMemo } from "react";

import MentionTextInput from "modules/core/components/MentionTextInput";

import { useSelectedProject } from "modules/projects/hooks/useSelectedProject";

type ChatTextInputProps = {
  value: string;
  onChange: (value: string) => void;
  onSend: () => void;
};

const ChatTextInput = forwardRef<{ focus: () => void }, ChatTextInputProps>(
  (props, ref) => {
    const { value, onChange, onSend } = props;

    const { rollups } = useSelectedProject();

    const projectOptions = useMemo(() => {
      return rollups.projects.map(project => ({
        label: project.name,
        id: project.id
      }));
    }, [rollups]);

    useImperativeHandle(ref, () => ({
      focus: () => {
        const input = document.getElementById("chat-input");
        if (input) {
          setTimeout(() => {
            input.focus();
          }, 0);
        }
      }
    }));

    useEffect(() => {
      const input = document.getElementById("chat-input");
      if (input) {
        input.focus();
      }
    }, []);

    return (
      <MentionTextInput
        mentions={projectOptions}
        mask="@Project[__label__](__id__)"
        value={value}
        onChange={onChange}
        onSubmit={onSend}
        placeholder="Ask Mosaic..."
        id="chat-input"
      />
    );
  }
);

export default ChatTextInput;
